var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "mt-2" },
        [
          _c(
            "b-card-body",
            [
              _c("validation-observer", {
                ref: "AddServiceOrder",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var invalid = ref.invalid
                      return [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.formSubmitted($event)
                              },
                              change: function ($event) {
                                return _vm.formChanged()
                              },
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Order Name*",
                                          "label-for": "mc-Order-name",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: "Order Name",
                                            vid: "Order Name",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Order-name",
                                                        placeholder:
                                                          "Order Name",
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details.orderName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "orderName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.orderName",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.HasPermission(
                                  _vm.PermissionList.Inventory_Create
                                )
                                  ? _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: "Warehouse*",
                                              "label-for": "textarea-default",
                                            },
                                          },
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                rules: "required",
                                                name: "Warehouse",
                                                vid: "Warehouse",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("b-form-select", {
                                                          attrs: {
                                                            disabled:
                                                              _vm.viewOnly,
                                                            options:
                                                              _vm.optionsWarehouse,
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.validateWarehouse,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.details
                                                                .warehouseId,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.details,
                                                                "warehouseId",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "details.warehouseId",
                                                          },
                                                        }),
                                                        errors.length
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Time Estimation*",
                                          "label-for": "mc-Time-Estimation",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required|min_value:0",
                                            name: "Time Estimation",
                                            vid: "Time Estimation",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Time-Estimation",
                                                        type: "number",
                                                        placeholder:
                                                          "Time Estimation",
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details
                                                            .timeEstimation,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "timeEstimation",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.timeEstimation",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Appointment Date*",
                                          "label-for": "appointmentDate",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Appointment Date",
                                            rules: { required: true },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-datepicker", {
                                                      attrs: {
                                                        id: "appointmentDate",
                                                        min: new Date(),
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details
                                                            .appointmentDate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "appointmentDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.appointmentDate",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Appointment Time*",
                                          "label-for": "appointmentTime",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Appointment Time",
                                            rules: { required: true },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-timepicker", {
                                                      attrs: {
                                                        id: "appointmentTime",
                                                        min: new Date(),
                                                        disabled: _vm.viewOnly,
                                                        locale: "en",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details
                                                            .appointmentTime,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "appointmentTime",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.appointmentTime",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-2", attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Assign Staff",
                                          "label-for": "textarea-default",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: { required: true },
                                            name: "Assign Staff",
                                            vid: "Assign Staff",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options:
                                                          _vm.staffOption,
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.assignStaffChanged,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details
                                                            .assignedStaffId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "assignedStaffId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.assignedStaffId",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-2", attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Assign Approver",
                                          "label-for": "textarea-default",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Assign Approver",
                                            vid: "Assign Approver",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options:
                                                          _vm.staffOption,
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.assignApproverChanged,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details
                                                            .assignedApproverId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "assignedApproverId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.assignedApproverId",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Price",
                                          "label-for": "mc-Price",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "min_value:0",
                                            name: "Price",
                                            vid: "Price",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _vm.HasPermission(
                                                      _vm.PermissionList
                                                        .ServiceManagement_Finance
                                                    )
                                                      ? _c("b-form-input", {
                                                          attrs: {
                                                            id: "mc-Price",
                                                            placeholder:
                                                              "Price",
                                                            step: "0.01",
                                                            type: "number",
                                                            disabled:
                                                              _vm.viewOnly,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.details.price,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.details,
                                                                "price",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "details.price",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "First Name*",
                                          "label-for": "mc-First-name",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required|max:250",
                                            name: "First Name",
                                            vid: "First Name",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-First-name",
                                                        placeholder:
                                                          "First name",
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details.firstName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "firstName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.firstName",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Last Name*",
                                          "label-for": "mc-Last-name",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required|max:250",
                                            name: "Last Name",
                                            vid: "Last Name",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Last-name",
                                                        placeholder:
                                                          "Last Name",
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details.lastName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "lastName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.lastName",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Email",
                                          "label-for": "mc-Email",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "email|min:0|max:250",
                                            name: "Email",
                                            vid: "Email",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Email",
                                                        placeholder: "Email",
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details.email,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "email",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.email",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "ContactNo*",
                                          "label-for": "mc-ContactNo",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required|numeric",
                                            name: "Contact No",
                                            vid: "Contact No",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-ContactNo",
                                                        placeholder:
                                                          "Contact No",
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details.contactNo,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "contactNo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.contactNo",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Comments",
                                          "label-for": "mc-Comments",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "min:0|max:250",
                                            name: "Comments",
                                            vid: "Comments",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Comments",
                                                        placeholder: "Comments",
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details.comments,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "comments",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.comments",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Location",
                                          "label-for": "mc-Location",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "min:0|max:250",
                                            name: "Location",
                                            vid: "Location",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Location",
                                                        placeholder: "Location",
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details.location,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "location",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.location",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Template",
                                          "label-for": "textarea-default",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: { required: true },
                                            name: "Template",
                                            vid: "Template",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options: _vm.template,
                                                        disabled: _vm.viewOnly,
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.templateChanged,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details
                                                            .selectedTemplateId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "selectedTemplateId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.selectedTemplateId",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Status",
                                          "label-for": "textarea-default",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: { required: true },
                                            name: "Status",
                                            vid: "Status",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        disabled: _vm.viewOnly,
                                                        options:
                                                          _vm.statusOptions,
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.StatusChanged,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.details.status,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.details,
                                                            "status",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "details.status",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Reference Number",
                                          "label-for": "mc-Time-Estimation",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Time-Estimation",
                                            type: "text",
                                            readonly: "",
                                            placeholder: "Reference Number",
                                            disabled: _vm.viewOnly,
                                          },
                                          model: {
                                            value: _vm.details.referenceNo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.details,
                                                "referenceNo",
                                                $$v
                                              )
                                            },
                                            expression: "details.referenceNo",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "div",
            {
              ref: "form",
              staticClass: "repeater-form",
              style: { height: _vm.trHeight },
            },
            _vm._l(_vm.invoiceData.items, function (item, index) {
              return _c(
                "b-row",
                { key: index, ref: "row", refInFor: true, staticClass: "pb-2" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", sm: "6", lg: "5" } },
                    [
                      _c("b-form-group", { staticClass: "w-100" }, [
                        _c(
                          "span",
                          { staticClass: "d-inline mb-1 font-weight-bold" },
                          [_vm._v("Item*")]
                        ),
                        _vm.optionsProduct.length === 0 || _vm.newProd
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center align-items-center w-100",
                              },
                              [
                                _c("b-spinner", {
                                  attrs: { variant: "primary" },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "flex-grow-1 w-100" },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "Item",
                                    vid: "Item" + index,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "align-items-center",
                                              },
                                              [
                                                _c("v-select", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    options: _vm.optionsProduct,
                                                    label: "itemTitle",
                                                    disabled: _vm.viewOnly,
                                                    clearable: false,
                                                    "append-to-body": "",
                                                    reduce: function (option) {
                                                      return option.value
                                                    },
                                                    placeholder: "Select Item",
                                                  },
                                                  on: {
                                                    input: function (val) {
                                                      return _vm.updateItemForm(
                                                        index,
                                                        val
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: item.id,
                                                    callback: function ($$v) {
                                                      _vm.$set(item, "id", $$v)
                                                    },
                                                    expression: "item.id",
                                                  },
                                                }),
                                                errors.length
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "qty-input",
                      attrs: { cols: "12", sm: "4", lg: "5" },
                    },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "span",
                            { staticClass: "d-inline d-lg-inline mr-2" },
                            [_vm._v("Quantity*")]
                          ),
                          _c("validation-provider", {
                            attrs: {
                              rules: "required|numeric|min_value:1",
                              name: "Quantity",
                              vid: "Quantity_" + index,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "flex-grow-1" },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              step: "1",
                                              disabled: _vm.viewOnly,
                                              type: "number",
                                            },
                                            model: {
                                              value: item.qty,
                                              callback: function ($$v) {
                                                _vm.$set(item, "qty", $$v)
                                              },
                                              expression: "item.qty",
                                            },
                                          }),
                                          errors.length
                                            ? _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center",
                      attrs: { cols: "12", sm: "2", lg: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { variant: "danger", size: "sm" },
                          on: {
                            click: function ($event) {
                              return _vm.removeFromItemForm(index)
                            },
                          },
                        },
                        [_vm._v(" Remove ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          !_vm.viewOnly
            ? _c(
                "b-row",
                { staticClass: "align-items-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(255, 255, 255, 0.15)",
                              expression: "'rgba(255, 255, 255, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mr-2",
                          attrs: { size: "sm", variant: "primary" },
                          on: { click: _vm.addNewItemInItemForm },
                        },
                        [_vm._v(" Add Item ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c(
              "div",
              [
                _c(
                  "div",
                  [
                    _c("validation-observer", {
                      ref: "AddServiceOrderDetails",
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var invalid = ref.invalid
                            return [
                              _c(
                                "b-form",
                                {
                                  ref: "tasks",
                                  staticClass: "repeater-form",
                                  style: { height: _vm.trHeight },
                                },
                                _vm._l(_vm.items, function (item, index) {
                                  return _c(
                                    "b-row",
                                    {
                                      key: item.id,
                                      ref: "row",
                                      refInFor: true,
                                      attrs: { id: item.id },
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Tasks*",
                                                "label-for": "item-tasks",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules:
                                                    "required|min:3|max:250",
                                                  name: "Tasks",
                                                  vid: "Tasks",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id:
                                                                "item-tasks_" +
                                                                index,
                                                              type: "text",
                                                              placeholder:
                                                                "Enter your tasks",
                                                              disabled:
                                                                _vm.viewOnly,
                                                            },
                                                            model: {
                                                              value: item.tasks,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "tasks",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.tasks",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "2" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Resources",
                                                "label-for": "resources",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules:
                                                    "required|min:0|max:250",
                                                  name: "Resources",
                                                  vid: "Resources",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id:
                                                                "resources_" +
                                                                index,
                                                              type: "text",
                                                              placeholder:
                                                                "Enter your resources",
                                                              disabled:
                                                                _vm.viewOnly,
                                                            },
                                                            model: {
                                                              value:
                                                                item.resources,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "resources",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.resources",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "2" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Tools",
                                                "label-for": "tools",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules:
                                                    "required|min:0|max:250",
                                                  name: "Tools",
                                                  vid: "Tools",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id:
                                                                "tools_" +
                                                                index,
                                                              type: "text",
                                                              placeholder:
                                                                "Enter your tools",
                                                              disabled:
                                                                _vm.viewOnly,
                                                            },
                                                            model: {
                                                              value: item.tools,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "tools",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.tools",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "2", md: "1" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Cost",
                                                "label-for": "price",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules:
                                                    "required|numeric_decimal|min_value:0",
                                                  name: "Price",
                                                  vid: "Price",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id:
                                                                "price_" +
                                                                index,
                                                              step: "0.01",
                                                              type: "number",
                                                              placeholder:
                                                                "Enter your price",
                                                              disabled:
                                                                _vm.viewOnly,
                                                            },
                                                            model: {
                                                              value: item.price,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "price",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.price",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "2", md: "1" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Status",
                                                "label-for": "Status",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  name: "Status",
                                                  vid: "status",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              options:
                                                                _vm.optionStatus,
                                                              disabled:
                                                                _vm.viewOnly,
                                                            },
                                                            model: {
                                                              value:
                                                                item.status,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "status",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.status",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "2", md: "1" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Comment",
                                                "label-for": "Comment",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  name: "Comment",
                                                  vid: "comment",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c(
                                                            "b-form-textarea",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.viewOnly,
                                                              },
                                                              model: {
                                                                value:
                                                                  item.comment,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "comment",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.comment",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      !_vm.viewOnly
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "mb-50",
                                              attrs: { lg: "2", md: "3" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "ripple",
                                                      rawName: "v-ripple.400",
                                                      value:
                                                        "rgba(234, 84, 85, 0.15)",
                                                      expression:
                                                        "'rgba(234, 84, 85, 0.15)'",
                                                      modifiers: { 400: true },
                                                    },
                                                  ],
                                                  staticClass: "mt-0 mt-md-2",
                                                  attrs: {
                                                    variant: "outline-danger",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeItem(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    staticClass: "mr-25",
                                                    attrs: { icon: "XIcon" },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("Delete"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c("b-col", { attrs: { cols: "12" } }, [
                                        _c("hr"),
                                      ]),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                !_vm.viewOnly
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "ripple",
                            rawName: "v-ripple.400",
                            value: "rgba(255, 255, 255, 0.15)",
                            expression: "'rgba(255, 255, 255, 0.15)'",
                            modifiers: { 400: true },
                          },
                        ],
                        attrs: { variant: "primary" },
                        on: { click: _vm.AddNew },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-25",
                          attrs: { icon: "PlusIcon" },
                        }),
                        _c("span", [_vm._v("Add New")]),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.viewOnly
                  ? _c(
                      "b-row",
                      { staticClass: "justify-content-end" },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "auto" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { variant: "outline-primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.formSubmitted()
                                  },
                                },
                              },
                              [_vm._v("Update")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c("DocumentUpload", {
                attrs: { documentDetails: _vm.documentDetails },
                on: {
                  deleteFile: _vm.deleteFile,
                  downloadFile: _vm.downloadFile,
                  uploadFiles: _vm.uploadFiles,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }